var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small-btn-sk mr-8"},[_c('a-skeleton',{attrs:{"active":"","title":false,"paragraph":{ rows: 1, width: '100%' }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }